export default __webpack_public_path__ + "static/media/ionicons.28c18785.svg";